import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MunicipalityService } from '../../../service/municipality/municipality.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectMunicipalityComponent),
  multi: true,
};

@Component({
  selector: 'app-select-municipality',
  templateUrl: './select-municipality.component.html',
  styleUrls: ['./select-municipality.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectMunicipalityComponent implements ControlValueAccessor,OnChanges {
    @Input() countryId: number;
    @Input() municipalityId: number;
    @Input() administrativeDivisionId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public municipalitiesOptions: any[];
    public outputObject: any;
    public countryIdAct: number;
    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];
    first: boolean = true;

    constructor(
        private renderer: Renderer2,
        public municipalityService: MunicipalityService
    ) {
        this.page = 1;
        this.per_page = 200;
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        //this.getMunicipalities(this.query, this.filters);
    }
    ngOnInit() {
        // this.getMunicipalities(this.query, this.filters);
    }
    ngOnChanges() {
        
        if(this.countryIdAct ==this.countryId || this.first)
        {
            this.first = false;
            if(this.administrativeDivisionId)
            {
                console.log(this.administrativeDivisionId);
                this.filters = [];
                this.filters.push({key: 'administrative_division_id', value: String(this.administrativeDivisionId)});
                this.getMunicipalities(this.query, this.filters);//this.ngOnInit();
            }
        }
        else{
            this.municipalitiesOptions = [];
            this.emitOutput(undefined);
        }
            
        this.countryIdAct = this.countryId;    
    }
    writeValue(value: any) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    public change($event) {
        // this.onMyChange.emit($event.target.value);
        // this.onChange($event.target.value);
        // this.onTouched($event.target.value);
        this.outputObject = this.municipalitiesOptions.find((item) => item.id == $event.target.value);
        this.emitOutput(this.outputObject);
    }

    getMunicipalities(query?: string, filters?: any[]) {
        this.municipalityService.getMunicipality(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                var municipalities = response.json().data;
                var statusFind= false;
                municipalities = this.sortData(municipalities, 'asc');

                this.municipalitiesOptions = [];
                this.municipalitiesOptions.push({id: undefined, name: 'choose', code_sorttime: undefined});
                municipalities.forEach(element => {
                    if (this.municipalityId == element.id) {
                        this.municipalitiesOptions.push({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        this.emitOutput({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        statusFind = true;
                    } 
                    else {
                        this.municipalitiesOptions.push({id: element.id, name: element.name, selected: false, code_sorttime: element.code_sorttime});
                    }
                });
                if(!statusFind)
                    this.emitOutput(undefined);
                
            },
            error => {
                this.municipalitiesOptions = [];
                this.municipalitiesOptions.push({id: '', name: 'Error'});
            }
        );
    }
    public emitOutput(value: any) {   
        this.onMyChange.emit(value);
        this.onChange(value);//this.onChange = "";//
        this.onTouched(value);//this.onTouched = ""; //
    }

    public sortData(data, type) {
        let ordered = [];
        let dataArr = [].slice.call(data);
        let dataSorted = dataArr.sort((a, b) => {
            if (type === "asc") {
                if (a.name < b.name) return -1
                else return 1
            } else {
                if (a.name > b.name) return -1
                else return 1
            }
        });
        dataSorted.forEach(e => {
            var words = e.name.split(" ");
            for(var i = 0; i < words.length; i++){
                words[i] = words[i].toLowerCase();
                if(words[i] != "y" && words[i] != "de")
                    words[i] = this.capitalize(words[i]);
            }
            e.name = words.join(" ");
            ordered.push(e);
        });
        return ordered;
    }

    public capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }
    
    public lowerCase(word){
        const palabras = word.toLowerCase();
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/municipalities/select-municipality/select-municipality.component.ts